import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getMtrTemplateApiErrorMessage(error, fallback = '操作失敗，請稍後再試') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'MTR_TEMPLATE_NOT_FOUND') {
    return data?.message || '找不到物料模板';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  return data?.message || fallback;
}

export function isMtrTemplateVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
